import { RiUploadLine } from 'react-icons/ri';
import { useNavigate } from 'react-router-dom';
import { useRef, useState, type ChangeEvent, type JSX } from 'react';
import background from '@/assets/svg/static/background.svg';
import logoFull from '@/assets/svg/static/logo-full.svg';
import upload from '@/assets/svg/static/upload.svg';
import { Footer } from '@/components/layout';
import { uploadImage } from '@/services/slaydAPI';
import { updatedImageUrl } from '@/utils/formatting';
import styles from './UploadPage.module.css';

const UploadPage = (): JSX.Element => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const navigate = useNavigate();
  const [isUploading, setIsUploading] = useState(false);

  const handleDivClick = (): void => {
    if (fileInputRef.current) fileInputRef.current.click();
  };

  const handleFileChange = async (
    event: ChangeEvent<HTMLInputElement>
  ): Promise<void> => {
    if (!event.target.files || !event.target.files.length) return;

    const uploadedFile = event.target.files[0];
    if (!uploadedFile) return;

    setIsUploading(true);

    try {
      // Upload image to backend (backend handles Firebase Storage)
      const response = await uploadImage(uploadedFile);

      // Format the URL for the API
      const formattedUrl = updatedImageUrl(response.url);

      // Navigate to similar products page with the uploaded image
      const params = new URLSearchParams();
      params.append('image_urls', formattedUrl);
      navigate(`/similar-product?${params.toString()}`);
    } catch (error) {
      console.error('Upload failed:', error);
      alert('Failed to upload image. Please try again.');
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div className={styles.parent}>
      <div className={styles.container}>
        <img src={background} alt="" className={styles.backgroundSvg} />
        <div className={styles.content}>
          <img src={logoFull} alt="Slayd Logo" className={styles.logo} />
          <p className={styles.tagline}>
            Fashion image search for India.
            <br />
            Better than Google Lens
          </p>
          <div className={styles.uploadContainer} onClick={handleDivClick}>
            <div className={styles.uploadBox}>
              <div className={styles.uploadIconWrapper}>
                <img src={upload} alt="Slayd Logo" />
              </div>
              <button className={styles.uploadButton} disabled={isUploading}>
                <input
                  type="file"
                  ref={fileInputRef}
                  className={styles.hiddenInput}
                  accept="image/*"
                  disabled={isUploading}
                  onChange={handleFileChange}
                />
                <RiUploadLine size={22} />
                {isUploading ? 'Uploading...' : 'Upload Image'}
              </button>
            </div>
            <div className={styles.uploadNote}>
              <h2 className={styles.uploadNoteText}>
                Currently available for Dresses only
              </h2>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default UploadPage;
